import axios from 'axios';
import { SaveFormat, manipulateAsync } from 'expo-image-manipulator';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { getRandomString } from '../../common/utils/utils';

// uploads file to s3 and returns file url
// fileName: will be generated if null passed; original file name will be used if undefined;
// example expo file object:
// {
// 	"cancelled":false,
// 	"height":1611,
// 	"width":2148,
// 	"uri":"file:///data/user/0/host.exp.exponent/cache/cropped1814158652.jpg"
//   }
export const s3upload = async (file, fileName = undefined, s3Path = '', getServerEndpoint, loadedMediaUri, mediaType, contentType, throwOnError = false) => {
	try {
		const fileParts = file.uri ? file.uri.split('.') : '';

		if (!file.uri && loadedMediaUri) {
			file.uri = loadedMediaUri;
		}

		fileName = fileName || (fileName === undefined ? [...fileParts].slice(0, -1).join('.') : getRandomString(50));

		// use mediaType if passed to props
		const fileType = mediaType || fileParts[fileParts.length - 1];

		const authToken = await AsyncStorage.getItem('token');

		const serverSignResponse = await axios.post(
			`${await getServerEndpoint()}/sign_s3`, {
				fileName,
				fileType,
				...(contentType ? { contentType } : {}),
				s3Path,
			},
			{
				headers: {
				// Add in the user's authorization header if available
				// NOTE: this only applies to browsers so direct
				// refernce to localStorage is fine
					authorization: `JWT ${authToken}`,
				},
			},
		);

		const compressedMedia = fileType === SaveFormat.JPEG || fileType === SaveFormat.PNG
			? await manipulateAsync(
				file.uri, [
					{
						resize: { height: 1620 },
					// automatically resize width
					},
				],
				{
					compress: 0.9,
					format: fileType,
				},
			)
			: file;

		const responseData = serverSignResponse?.data;
		const returnData = responseData?.data?.returnData;

		// Guard against unexpected sign response to avoid crashes on missing payload.
		if (!responseData?.success || !returnData?.signedRequest || !returnData?.url) {
			const responseError = responseData?.error?.message || responseData?.error || 'Missing signed upload data';
			console.log('S3 sign response invalid', responseError);
			return '';
		}

		const { signedRequest, url } = returnData;

		const actualFile = await fetch(compressedMedia.uri);
		const blobFile = await actualFile.blob();

		const options = {
			headers: {
				'Content-Type': contentType || fileType,
				'Cache-Control': 'max-age=2592000',
			},
			method: 'PUT',
			body: blobFile,
		};

		const uploadResponse = await fetch(signedRequest, options);
		if (!uploadResponse.ok) {
			console.log('S3 upload failed', uploadResponse.status);
			return '';
		}

		return url;
	}
	catch (e) {
		if (throwOnError) {
			throw e;
		}
		console.log(e);
		return '';
	}
};
